import {
  collection,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  getDocs,
  query,
  orderBy,
  serverTimestamp,
  Timestamp,
  writeBatch,
} from "firebase/firestore";
import { db } from "./config";
import { ContentBlock } from "../types/courseBlocks";
import { ImpactSlide } from "../types/impactSlides";

export interface Article {
  id?: string;
  slug: string;
  title: string;
  tagline: string;
  labels?: string[];
  coverImageUrl?: string;
  coverImageIsPlaceholder?: boolean;
  published: boolean;
  featured?: boolean;
  impactSlides?: ImpactSlide[];
  impactAnimated?: boolean;
  order: number;
  blocks: ContentBlock[];
  createdAt?: Timestamp;
  updatedAt?: Timestamp;
}

const articlesCollection = collection(db, "articles");

export const getAllArticles = async (): Promise<Article[]> => {
  const snapshot = await getDocs(query(articlesCollection, orderBy("order", "asc")));
  return snapshot.docs.map((docSnap) => ({ id: docSnap.id, ...docSnap.data() } as Article));
};

export const createArticle = async (
  article: Omit<Article, "id" | "createdAt" | "updatedAt">
): Promise<string> => {
  const docRef = await addDoc(articlesCollection, {
    ...article,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  return docRef.id;
};

export const updateArticle = async (
  id: string,
  article: Partial<Omit<Article, "id" | "createdAt" | "updatedAt">>
): Promise<void> => {
  await updateDoc(doc(db, "articles", id), {
    ...article,
    updatedAt: serverTimestamp(),
  });
};

export const deleteArticle = async (id: string): Promise<void> => {
  await deleteDoc(doc(db, "articles", id));
};

export const reorderArticles = async (orderedIds: string[]): Promise<void> => {
  const batch = writeBatch(db);
  orderedIds.forEach((id, index) => {
    batch.update(doc(db, "articles", id), { order: index, updatedAt: serverTimestamp() });
  });
  await batch.commit();
};
